export { default as PaymentInfo } from './ui/PaymentInfo'
